// extracted by mini-css-extract-plugin
var _1 = "ViewingApplicantsFormFields-modulefields__AU6kr";
export { _1 as "fields" }
